import { useState } from 'react'

interface SearchBarProps {
  value: string
  onChangeText: (text: string) => void
  onOpenFilters: () => void
  placeholder?: string
}

export default function SearchBar({
  value,
  onChangeText,
  onOpenFilters,
  placeholder = "Search by player, team, or item…"
}: SearchBarProps) {
  const [isFocused, setIsFocused] = useState(false)

  return (
    <div className="mb-6">
      <div className={`flex items-center bg-white rounded-lg border-2 px-4 py-3 transition-colors ${
        isFocused ? 'border-brand-primary' : 'border-gray-200'
      }`}>
        {/* Search Icon */}
        <svg 
          className="w-5 h-5 text-gray-400 mr-3"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
        >
          <circle cx={11} cy={11} r={8} />
          <path d="m21 21-4.35-4.35" />
        </svg>

        {/* Search Input */}
        <input
          type="text"
          value={value}
          onChange={(e) => onChangeText(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          placeholder={placeholder}
          className="flex-1 outline-none text-gray-900 placeholder-gray-500"
        />

        {/* Filter Button */}
        <button
          onClick={onOpenFilters}
          className="ml-3 p-2 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Open filters"
        >
          <svg 
            className="w-5 h-5"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
          >
            <line x1={4} y1={21} x2={4} y2={14} />
            <line x1={4} y1={10} x2={4} y2={3} />
            <line x1={12} y1={21} x2={12} y2={12} />
            <line x1={12} y1={8} x2={12} y2={3} />
            <line x1={20} y1={21} x2={20} y2={16} />
            <line x1={20} y1={12} x2={20} y2={3} />
            <line x1={1} y1={14} x2={7} y2={14} />
            <line x1={9} y1={8} x2={15} y2={8} />
            <line x1={17} y1={16} x2={23} y2={16} />
          </svg>
        </button>
      </div>
    </div>
  )
}